(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Formio"));
	else if(typeof define === 'function' && define.amd)
		define(["Formio"], factory);
	else if(typeof exports === 'object')
		exports["ngformio"] = factory(require("Formio"));
	else
		root["ngformio"] = factory(root["Formio"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_formiojs__) {
return 